import { useParams, useNavigate, useLocation } from "react-router";

export const useI18n = () => {
  const { lang = "en" } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // for string translation
  const l = <EN extends string, FR extends string>(
    enStr: EN,
    frStr?: FR,
    options?: { langCode?: "en" | "fr" }
  ): EN | FR => {
    const langCode = options?.langCode || lang || "en";
    return langCode === "en" ? enStr : frStr || enStr;
  };

  // for component translation
  const lc = ({ en, fr }: { en: React.ReactNode; fr?: React.ReactNode }, options?: { langCode?: "en" | "fr" }) => {
    const langCode = options?.langCode || lang || "en";
    return langCode === "en" ? en : fr || en;
  };

  // Language Switcher Function - Preserve current path
  const switchLanguage = (newLang: "en" | "fr") => {
    if (lang === newLang) return;

    let newPath = location.pathname;
    newPath = newPath.endsWith("/") && newPath !== "/" ? newPath.slice(0, -1) : newPath;

    // if the current path has fr, remove it
    if (newPath.startsWith("/fr/") || newPath.startsWith("/en/")) {
      newPath = newPath.slice(3);
    }

    // if the current path === "/fr" or "/en", remove it
    if (newPath === "/fr" || newPath === "/en") {
      newPath = "/";
    }

    // add the new lang to the path (if it's fr)
    if (newLang === "fr") {
      newPath = `/fr${newPath}`;
    }

    // Use navigate instead of window.location.href to preserve component state
    navigate(`${newPath}${location.hash ? location.hash : ""}${location.search ? location.search : ""}`, {
      replace: true,
    });
  };

  return { l, lc, langCode: lang, lang, switchLanguage };
};
